import {
  CHATBOT_TRAINING_EXAMPLES_PAGE_SIZES,
  type ChatbotTrainingExamplesPageSize,
} from '../../../types/userConfig';
import { useUserConfig } from '../../../userConfig/useUserConfig';
import { useChatbotTrainingExamplesListSearchParams } from './useChatbotTrainingExamplesListSearchParams';
import { useChatbotTrainingExamplesQuery } from '../queries/useChatbotTrainingExamplesQuery';

export function useChatbotTrainingTab(chatbotId: string, enabled: boolean) {
  const {
    chatbotTrainingExamplesPageSize,
    setChatbotTrainingExamplesPageSize,
    isUserConfigReady,
  } = useUserConfig();
  const {
    page,
    setPage,
    searchInput,
    listOptions,
    hasActiveTrainingSearch,
    handleSearchChange,
  } = useChatbotTrainingExamplesListSearchParams(
    chatbotTrainingExamplesPageSize,
  );

  const trainingExamplesQuery = useChatbotTrainingExamplesQuery(
    chatbotId,
    listOptions,
    enabled && isUserConfigReady,
  );

  const examples = trainingExamplesQuery.data ?? [];
  const hasPreviousPage = page > 1;
  const hasNextPage = examples.length === chatbotTrainingExamplesPageSize;
  const isPageLoading =
    !isUserConfigReady || (enabled && trainingExamplesQuery.isLoading);

  const handleManualRefresh = () => {
    void trainingExamplesQuery.refetch();
  };

  const handlePageSizeChange = (value: string) => {
    const parsedValue = Number(value);
    if (
      !CHATBOT_TRAINING_EXAMPLES_PAGE_SIZES.some((size) => size === parsedValue)
    ) {
      return;
    }
    setChatbotTrainingExamplesPageSize(
      parsedValue as ChatbotTrainingExamplesPageSize,
    );
    setPage(1);
  };

  return {
    trainingExamplesQuery,
    examples,
    page,
    setPage,
    searchInput,
    listOptions,
    hasActiveTrainingSearch,
    handleSearchChange,
    hasPreviousPage,
    hasNextPage,
    chatbotTrainingExamplesPageSize,
    handlePageSizeChange,
    handleManualRefresh,
    isPageLoading,
  };
}
